// File: src/pages/styles/WaitlistStyles.js
import berryBg from '../../images/berryBg-removebg.png';

const WaitlistStyles = (theme) => ({
  ...theme.custom,
  waitlistContainer: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    left: 0,
    top: 0,
    width: '100%',
    height: '100vh',
    textAlign: 'center',
    padding: '24px',
    backgroundImage: `url(${berryBg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  textContainer: {
    backgroundColor: '#fff',
    padding: '32px',
    borderRadius: '16px',
    maxWidth: '75%',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  pageTitle: {
    fontSize: '3rem',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    marginBottom: '32px',
  },
  explanationText: {
    fontSize: '1.5rem',
    color: theme.palette.text.primary,
    marginBottom: '32px',
  },
  textField: {
    margin: '10px auto 10px auto'
  },
  button: {
    marginTop: 20,
    marginBottom: 20,
    position: 'relative',
    borderRadius: '20px',
    padding: '8px 16px',
    textTransform: 'none',
    color: '#fff',
    '&:hover': {
      opacity: 0.9,
    },
  },
  waitlistButton: {
    backgroundColor: '#5E2A84', // Different color for Join Waitlist button
    '&:hover': {
      backgroundColor: '#4B0082',
    },
  },
  discordButton: {
    backgroundColor: '#7289DA', // Discord color for both Discord-related buttons
    '&:hover': {
      backgroundColor: '#5E76BA',
    },
  },
  discordButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px', // This adds space between the Discord buttons
    marginTop: '20px',
  },
});

export default WaitlistStyles;